export const GET_USER = 'GET_USER';
export const GET_ALL_USER = 'GET_ALL_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const DELETE_USER = 'DELETE_USER';
export const CHANGE_USER_STATUS = 'CHANGE_USER_STATUS';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';